import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';

import s from 'components/editor/pages/about/timeline/logoVideo.sss';

// Videos encoded with (replace input, overlay, and output accordingly ; gradient overlay images available in the videos folder on stage):
// INPUT="logo-1912-raw.mp4" OVERLAY="1912-grad.png" OUTPUT="logo-1912-av1.mp4" CRF=40 CPU=3 bash -c 'ffmpeg -y -i "$INPUT" -i "$OVERLAY" -filter_complex "[0:v][1:v] overlay" -pix_fmt yuv420p -an -c:v libaom-av1 -cpu-used "$CPU" -crf "$CRF" -pass 1 -f null /dev/null && ffmpeg -y -i "$INPUT" -i "$OVERLAY" -filter_complex "[0:v][1:v] overlay" -pix_fmt yuv420p -c:a libopus -b:a 64k -c:v libaom-av1 -cpu-used "$CPU" -crf "$CRF" -pass 2 -movflags +faststart "$OUTPUT"'
// INPUT="logo-1912-raw.mp4" OVERLAY="1912-grad.png" OUTPUT="logo-1912-hevc.mp4" CRF=30 PRESET="veryslow" bash -c 'ffmpeg -y -i "$INPUT" -i "$OVERLAY" -filter_complex "[0:v][1:v] overlay" -pix_fmt yuv420p -c:a libopus -b:a 64k -c:v libx265 -preset "$PRESET" -crf "$CRF" -tag:v hvc1 -movflags +faststart "$OUTPUT"'

export default class LogoVideo extends Component {

	constructor(props) {
		super(props);
		this.state = {
			muted: true,
			playing: true,
			interrupted: false,
			preload: false,
			ended: false,
		};
		this.loaded = false;
		this.onEnterViewport = this.onEnterViewport.bind(this);
		this.onEnded = this.onEnded.bind(this);
		this.onAnyVideoUnmute = this.onAnyVideoUnmute.bind(this);
		this.toggleMute = this.toggleMute.bind(this);
		this.mute = this.toggleMute.bind(this, true);
		this.togglePlay = this.togglePlay.bind(this);
		this.pause = this.togglePlay.bind(this, false);
		this.play = this.togglePlay.bind(this, true);
	}

	componentDidMount() {
		window.addEventListener('powster-video-unmute', this.onAnyVideoUnmute);
		this.intersectionObserver = new IntersectionObserver(this.onEnterViewport, { threshold: 0, rootMargin: '80px 0px 80px 0px' });
		this.intersectionObserver.observe(this.base.querySelector(`.${s.videoWrapper}`));
	}

	componentWillUnmount() {
		window.removeEventListener('powster-video-unmute', this.onAnyVideoUnmute);
		this.intersectionObserver?.disconnect();
	}

	onEnterViewport(entries) {
		const intersecting = entries.some(entry => entry.isIntersecting);
		if (intersecting && !this.state.preload) {
			this.setState({ preload: true });
			if (this.state.playing) {
				this.uninterrupt();
			}
			// Only need to trigger it once
			this.intersectionObserver?.disconnect();
			this.intersectionObserver = null;
		}
	}

	onEnded() {
		this.setState({ playing: false, ended: true });
	}

	onAnyVideoUnmute({ detail }) {
		if (detail?.component !== this) {
			this.toggleMute(true);
		}
	}

	toggleMute(newState) {
		const muted = typeof newState === 'boolean' ? newState : !this.state.muted;
		if (muted === this.state.muted) return;
		this.setState({ muted });
		Store.emit('ABOUT_VIDEO_SLIDE_MUTE_TOGGLE', { state: muted });
		if (!muted) {
			window.dispatchEvent(new CustomEvent('powster-video-unmute', { detail: { component: this, video: this.base.querySelector('video') } }));
		}
	}

	togglePlay(newState) {
		const playing = typeof newState === 'boolean' ? newState : !this.state.playing;
		if (playing === this.state.playing) return;
		if (!playing && this.state.ended) return;
		this.setState({ playing, ended: false });
		Store.emit('ABOUT_VIDEO_SLIDE_PLAY_TOGGLE', { state: !playing });
		const video = this.base.querySelector('video');
		if (!playing) {
			video?.pause();
		} else if (!this.state.interrupted) {
			video?.play();
		}
	}

	interrupt() {
		this.setState({ interrupted: true });
		this.base.querySelector('video')?.pause();
	}
	uninterrupt() {
		this.setState({ interrupted: false });
		if (this.state.playing) {
			this.base.querySelector('video')?.play();
		}
	}

	render({ file, poster }, state) {
		return (
			<div class={joinClasses(s.wrapper, state.ended && s.ended)}>
				<div class={s.controls}>
					<button
						class={state.muted ? s.muted : s.unmuted}
						onClick={this.toggleMute}
						aria-label={state.muted ? 'Unmute video' : 'Mute video'}
						data-section="#"
					/>
					<button
						class={state.playing ? s.pause : s.play}
						onClick={this.togglePlay}
						aria-label={state.playing ? 'Pause video' : 'Play video'}
						data-section="#"
					/>
				</div>
				<div class={s.videoWrapper} style={`--poster: url('${poster}')`}>
					<video
						class={s.video}
						src={file}
						preload={state.preload ? 'auto' : 'none'}
						muted={state.muted}
						playsInline
						onEnded={this.onEnded}
						// width="854"
						// height="480"
						poster={poster}
						key={file}
						autoplay
					/>
				</div>
			</div>
		);
	}
}